export const storeToken = (token) =>
  sessionStorage.setItem("playground_accessToken", token);
export const removeToken = () =>
  sessionStorage.removeItem("playground_accessToken");
export const getToken = () => sessionStorage.getItem("playground_accessToken");
